"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FactoryFieldFile = void 0;
var type_guard_1 = require("@webnuts/type-guard");
var InputFile_1 = require("./InputFile");
var Field_1 = require("../../internal/components/Field");
var factory_1 = require("../../internal/factory");
var factory_utils_1 = require("../../internal/factory-utils");
exports.FactoryFieldFile = factory_1.factory({
    prefix: 'FieldFile',
    settings: {
        field: type_guard_1.props(Field_1.fieldSettings),
        input: type_guard_1.props(InputFile_1.inputFileSettings)
    },
    component: function (_a, utils, displayName) {
        var input = _a.input, field = _a.field;
        return factory_utils_1.createFieldWithInput(displayName, Field_1.FactoryField('Field', field, utils), InputFile_1.FactoryInputFile('InputFile', input, utils));
    }
}).FactoryFieldFile;
